import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../components/UI/Button';
import { Input, Select } from '../components/UI/Input';
import { useApp } from '../context/AppContext';
import './Auth.css';

export default function Register() {
  const navigate = useNavigate();
  const { register } = useApp();
  const [form, setForm] = useState({ name: '', company: '', email: '', password: '', plan: 'pro', agree: false });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.agree) { setError("Vous devez accepter les conditions d'utilisation."); return; }
    setLoading(true);
    setError('');
    try {
      await register({
        name:     form.name,
        company:  form.company,
        email:    form.email,
        password: form.password,
        plan:     form.plan,
        agree:    form.agree,
      });
      navigate('/onboarding');
    } catch (err) {
      setError(err.message || 'Une erreur est survenue lors de la création du compte.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page auth-page-col">
      <div className="auth-brand">
        <span className="auth-logo"><b>bee</b>appee</span>
        <span className="auth-tagline">Le génie de tes relations</span>
      </div>

      <div className="auth-card" style={{ maxWidth: 480 }}>
        <h1 className="auth-title">Crée ton compte</h1>
        <p className="auth-sub">14 jours d'essai gratuit, sans carte de crédit — tu choisis (ou changes) de plan plus tard</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div style={{ display: 'flex', gap: 12 }}>
            <Input label="Ton nom" placeholder="Jean-Marc Dupont" value={form.name} onChange={e => set('name', e.target.value)} required />
            <Input label="Ton entreprise" placeholder="Garage Dupont SA" value={form.company} onChange={e => set('company', e.target.value)} required />
          </div>
          <Input label="E-mail professionnel" type="email" placeholder="toi@entreprise.ch" value={form.email} onChange={e => set('email', e.target.value)} required />
          <Input label="Mot de passe" type="password" placeholder="8 caractères minimum" value={form.password} onChange={e => set('password', e.target.value)} required minLength={8} />

          <div>
            <Select label="Plan d'essai (gratuit 14 jours, modifiable à tout moment)" value={form.plan} onChange={e => set('plan', e.target.value)}>
              <option value="starter">Starter — CHF 49/mois (500 contacts)</option>
              <option value="pro">Pro — CHF 149/mois (5'000 contacts)</option>
              <option value="premium">Premium — CHF 299/mois (25'000 contacts)</option>
            </Select>
            <div style={{ fontSize: 11.5, color: 'var(--muted)', marginTop: 4 }}>
              Rien n'est débité pendant l'essai — pas de carte demandée.
            </div>
          </div>

          <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start', cursor: 'pointer' }}>
            <input type="checkbox" checked={form.agree} onChange={e => set('agree', e.target.checked)} style={{ marginTop: 2 }} />
            <span style={{ fontSize: 13, color: 'var(--muted)' }}>
              J'accepte les <a href="https://beeappee.com/cgu" target="_blank" rel="noreferrer" style={{ color: 'var(--violet)', fontWeight: 600 }}>Conditions d'utilisation</a> et la <a href="https://beeappee.com/confidentialite" target="_blank" rel="noreferrer" style={{ color: 'var(--violet)', fontWeight: 600 }}>Politique de confidentialité</a>
            </span>
          </label>

          {error && <div className="auth-error">{error}</div>}

          <Button type="submit" loading={loading} style={{ width: '100%' }}>
            Créer mon compte gratuitement →
          </Button>
        </form>

        <div className="auth-footer">
          Déjà un compte ? <Link to="/login" className="auth-link">Se connecter</Link>
        </div>
      </div>
    </div>
  );
}
